import { render, staticRenderFns } from "./ResultsMonitor.vue?vue&type=template&id=37e1f2dc&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ResultsMonitor.vue?vue&type=script&lang=ts"
export * from "./ResultsMonitor.vue?vue&type=script&lang=ts"
import style0 from "./ResultsMonitor.vue?vue&type=style&index=0&id=37e1f2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1f2dc",
  null
  
)

export default component.exports